import React from 'react'
import { EndPointDoc } from './apireftypes';
import { ApiParameters } from './apiparameters';
import { ApiOutput } from './apioutput';
import { ApiExampleCode } from './apiexamplecode';
import { ApiExampleOutput } from './apiexampleoutput';
import { Document } from '../landingpage/components/document';
import { Util } from '../fasades/util';
import './apiendpoint.css';

interface Props {
    doc : EndPointDoc;
}

interface State {
    selectedExampleIndex: number;
}

export class ApiEndPoint extends React.Component<Props, State> 
{
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedExampleIndex: 0
        };
    }

    handleExampleChange = (index: number) => {
        this.setState({ selectedExampleIndex: index });
    }

    render() {
        const hasExamples = this.props.doc.examples !== undefined && this.props.doc.examples.length > 0;
        const validIndex = hasExamples 
            ? Math.min(this.state.selectedExampleIndex, this.props.doc.examples!.length - 1)
            : 0;
        const selectedExample = hasExamples 
            ? this.props.doc.examples![validIndex]
            : undefined;

        return (
            <>

            <title>{this.props.doc.title}</title>
            <meta
                    name="description"
                    content={this.props.doc.seoDescription }
            />
            <link rel="canonical" href={Util.getTigerCityUrl() + "apidoc/" + this.props.doc.docurl} />

            <div className="api-endpoint-container">
                <div className="api-endpoint-documentation">
                   <Document classes="main apidocs">
                    <h1>{this.props.doc.title}</h1>

                    <div className="endpointinfo">
                        <div className="method">{ this.props.doc.method }</div>
                        <div className="url">{ this.props.doc.url }</div>
                    </div>

                    { this.props.doc.description }

                    { (this.props.doc.parameters !== undefined && this.props.doc.parameters.length > 0) &&
                        <ApiParameters parameters={this.props.doc.parameters}/>
                    }
                    { selectedExample !== undefined && selectedExample.responseType !== undefined && 
                        <ApiOutput outputType={ selectedExample.responseType }/>
                    }
                    </Document>
                </div>

                { hasExamples && (
                    <div className="api-endpoint-examples" suppressHydrationWarning={true}>
                        <ApiExampleCode
                            title={this.props.doc.title}
                            examples={this.props.doc.examples!}
                            onExampleChange={this.handleExampleChange}
                        />
                        { selectedExample !== undefined && selectedExample.output !== undefined && (
                            <ApiExampleOutput
                                output={selectedExample.output}
                                title={(selectedExample.title ? ` (${selectedExample.title})` : '')}
                            />
                        )}
                    </div>
                )}
            </div>
            </>
        )
    }
}

